import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import {
  ObtenerProgresoCursoPorPersonaCurso, ObtenerProgresoCursoPorPersonaPrograma,
  ObtenerEvaluacionesPersonaPrograma, 
} from "../../services/CursoService";
import { ListarUnidadesPorCurso } from "../../services/UnidadService";
import "./styles/ProgresoCurso.scss";
import { ProgressSpinner } from "primereact/progressspinner";

import { ListarBibliotecasPorCurso } from "../../services/BibliotecaServices";
import { ListarLeccionesPorUnidad } from "../../services/LeccionServices";

import FooterInterno from "../../components/Footer/FooterInterno";
import useAlumno from "../../hooks/useAlumno";
import { BuscarProgramaID } from "../../services/ProgramaService";
import {
  ActualizarCursoEstado,
  ObtenerCursosPorUsuarioCurso,
  ObtenerPersonaPorId, ObtenerCursosPorPersonaPrograma, ObtenerCursosPorUsuario, ObtenerUnidadesPorPersonaPrograma,
  ObtenerLeccionesPorPersonaPrograma, ObtenerPersonaProgramaPorIdPersonaPrograma
} from "../../services/UsuarioService";
import CardDownloadPrograma from "../components/CardDownloadPrograma/CardDownloadPrograma";

import { ObtenerEvaluacionesPersonaCurso } from "../../services/EvaluacionService";

import DialogZegel from "../../components/Dialog/DialogZegel";
import AvanceModulosComponent from "../components/AvanceModulos/AvanceModulosComponent";
import BibliotecaVirtualComponent from "../components/BibliotecaVirtual/BibliotecaVirtualComponent";
import CardBienvenidaProgramaComponent from "../components/CardBienvenidaPrograma/CardBienvenidaProgramaComponent";
import CardCursoVideoInicioComponent from "../components/CardCursoVideoInicio/CardCursoVideoInicioComponent";
import MiProgresoTituloComponent from "../components/MiProgresoTitulo/MiProgresoTituloComponent";
import ModulosAcordionProgramaComponent from "../components/ModulosAcordionPrograma/ModulosAcordionProgramaComponent";
import PreguntasFrecuentesComponent from "../components/PreguntasFrecuentes/PreguntasFrecuentesComponent";
import LoadingGlobal from "../components/LoadingGlobal/LoadingGlobal";

const ProgresoPrograma = () => {
  const navigate = useNavigate();
  let { perfil } = useAlumno();
  let { idPrograma } = useParams();
  let { idPersonaPrograma } = useParams();
  const [curso, setCurso] = useState({ nombre: "" });
  const [listaBiblioteca, setListaBiblioteca] = useState([]);
  const [cursoPersona, setcursoPersona] = useState([{ idEstado: 2 }]);
  const [Persona, setPersona] = useState([]);
  const [programa, setPrograma] = useState([]);
  const [listaCursoPrograma, setlistaCursoPrograma] = useState(null);
  const [loadingGlobal, setLoadingGlobal] = useState(false);
  const [listaUnidadeCursoPrograma, setlistaUnidadeCursoPrograma] =
    useState(null);
  const [
    listaLeccionUnidadeCursoPrograma,
    setlistaLeccionUnidadeCursoPrograma,
  ] = useState(null);
  const [
    listaProgresoLeccionUnidadeCursoPrograma,
    setlistaProgresoLeccionUnidadeCursoPrograma,
  ] = useState(null);

  const [
    listaEvaluacionesUnidadeCursoPrograma,
    setlistaEvaluacionesUnidadeCursoPrograma,
  ] = useState(null);

  const [showAlert, setShowAlert] = useState(null);
  const [contenidoAlertActivar, setContenidoAlertActivar] = useState(null);
  const [cursoActivarSeleccion, setcursoActivarSeleccion] = useState(null);
  const [listaCursosProgramasPersona, setListaCursosProgramasPersona] = useState(null);
  const [cursosActivos, setCursosActivos] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ListUnidadesPorPersonaPrograma, setListUnidadesPorPersonaPrograma] = useState(null);
  const [ListLeccionesPorPersonaPrograma, setListLeccionesPorPersonaPrograma] = useState(null);
  const [ListProgresoCursoPorPersonaPrograma, setListProgresoCursoPorPersonaPrograma] = useState(null);
  const [ListEvaluacionesPersonaPrograma, setListEvaluacionesPersonaPrograma] = useState(null);
  const [GetProgramaEjecutado, setGetProgramaEjecutado] = useState(false)
  const [spinnerCertificado, setspinnerCertificado] = useState(false);
  const [spinnerNotas, setspinnerNotas] = useState(false);
  const [PersonaProgamaData, setPersonaProgamaData] = useState(null);
  const [LeccionesPendientes, setLeccionesPendientes] = useState(null);
  
  let idCursosRepetidos;
  let jwt = window.localStorage.getItem("jwt");
  useEffect(() => {
    setLoadingGlobal(true)
   
    if (idPersonaPrograma != null && ListUnidadesPorPersonaPrograma == null) {
      ObtenerUnidadesPorPersonaPrograma({ jwt, id: idPersonaPrograma }).then(async (data) => {
        setListUnidadesPorPersonaPrograma(data);
      })
    }
    // ObtenerCursosPorUsuario({ jwt, idUsuario }).then((data) => {
    //   const idCursos = data.map(curso => curso.idCurso);
    //   idCursosRepetidos = idCursos.filter((idCurso, index) => idCursos.indexOf(idCurso) !== index);
    // })
  }, [idPersonaPrograma]);

  useEffect(() => {
    if (ListUnidadesPorPersonaPrograma != null && ListLeccionesPorPersonaPrograma == null) {
      ObtenerLeccionesPorPersonaPrograma({ jwt, id: idPersonaPrograma }).then(async (data) => {
        setListLeccionesPorPersonaPrograma(data);
      })
    }
  }, [ListUnidadesPorPersonaPrograma]);

  useEffect(() => {
    if (ListUnidadesPorPersonaPrograma != null && ListLeccionesPorPersonaPrograma != null && ListProgresoCursoPorPersonaPrograma == null) {
      ObtenerProgresoCursoPorPersonaPrograma({ jwt, id: idPersonaPrograma }).then(async (data) => {
        setListProgresoCursoPorPersonaPrograma(data);
      })
    }
  }, [ListLeccionesPorPersonaPrograma]);

  useEffect(() => {
    if (ListUnidadesPorPersonaPrograma != null && ListLeccionesPorPersonaPrograma != null && ListProgresoCursoPorPersonaPrograma != null) {
      ObtenerEvaluacionesPersonaPrograma({ jwt, id: idPersonaPrograma }).then(async (data) => {
        setListEvaluacionesPersonaPrograma(data);
      })
    }
  }, [ListProgresoCursoPorPersonaPrograma]);

  useEffect(() => {
    ObtenerPersonaProgramaPorIdPersonaPrograma({ jwt, id: idPersonaPrograma }).then(async (data) => {
      setPersonaProgamaData(data);
    })
  }, [idPersonaPrograma]);

  useEffect(() => {
    if (ListEvaluacionesPersonaPrograma != null) {
      setGetProgramaEjecutado(true);
      let jwt = window.localStorage.getItem("jwt");
      var idUsuario = perfil.idUsuario.toString();
      if (idUsuario != undefined) {
        ObtenerPersonaPorId({ jwt, idPersona: idUsuario }).then((dataP) => {
          setPersona(dataP);
        });
      }
      BuscarProgramaID({ jwt, idPrograma }).then(async (data) => {
        setPrograma(data);
        var auxsetcursoPersona = [];
        var auxlistaUnidadeCursoPrograma = [];
        var auxlistaLeccionUnidadeCursoPrograma = [];
        var auxlistaProgresoLeccionUnidadeCursoPrograma = [];
        var auxsetListaBiblioteca = [];
        var auxlistaEvaluacionesUnidadeCursoPrograma = [];
        var vLeccionesPendientesUnidades = [];
        await ObtenerCursosPorPersonaPrograma({ jwt, id: idPersonaPrograma }).then(
          async (data) => {
            for (var i = 0; i < data.length; i++) {
              var idCurso = data[i].idCurso;
              /* await ObtenerCursosPorUsuarioCurso({ jwt, idUsuario, idCurso }).then(
                async (data) => { */
              auxsetcursoPersona.push(data[i]);
              if (data.length > 0) {
                var idPersonaCurso = data[i].idPersonaCurso;
                var ListProgresoCursoPorPersonaProgramaFilter = ListProgresoCursoPorPersonaPrograma?.filter(z => z.idPersonaCurso === idPersonaCurso)
                if (ListProgresoCursoPorPersonaProgramaFilter === undefined) { ListProgresoCursoPorPersonaProgramaFilter = [] }
                var ListEvaluacionesPersonaProgramaFilter = ListEvaluacionesPersonaPrograma.filter(a => a.idPersonaCurso === idPersonaCurso);
                for (var eva = 0; eva < ListEvaluacionesPersonaProgramaFilter.length; eva++) {
                  auxlistaEvaluacionesUnidadeCursoPrograma.push(
                    ListEvaluacionesPersonaProgramaFilter[eva]
                  );
                }
                
                var auxProgresoUnidad = [];
                var dataUnidades = ListUnidadesPorPersonaPrograma.filter(x => x.idCurso === idCurso);
                for (var k = 0; k < dataUnidades.length; k++) {
                  auxlistaUnidadeCursoPrograma.push(dataUnidades[k]);
                  let idUnidad = dataUnidades[k].idUnidad;
                  var vLeccionesPendientesUnidad ={
                    idCurso:idCurso,
                    idUnidad: idUnidad,
                    leccionesPendientes:[]
                  }
                  var dataLecciones = ListLeccionesPorPersonaPrograma.filter(y => y.idUnidad === idUnidad);
                  for (var j = 0; j < dataLecciones.length; j++) {
                    auxlistaLeccionUnidadeCursoPrograma.push(dataLecciones[j]);
                    const resultadosFiltrados = ListProgresoCursoPorPersonaProgramaFilter.filter(
                      (item) => item.idLeccion === dataLecciones[j].idLeccion
                    );
                    var porcentaje = 0;
                    if (resultadosFiltrados.length > 0) {
                      const fechaActual = new Date(resultadosFiltrados[0].tiempoVideoActual);
                      const fechaTotal = new Date(resultadosFiltrados[0].tiempoVideoTotal);
                      const opcionesHora = { hour: "2-digit", minute: "2-digit", second: "2-digit", };
                      const horaActual = fechaActual.toLocaleTimeString("es-ES", opcionesHora);
                      const horaTotal = fechaTotal.toLocaleTimeString("es-ES", opcionesHora);
                      const parteshoraActual = horaActual.split(":");
                      const horashoraActual = parseInt(parteshoraActual[0], 10);
                      const minutoshoraActual = parseInt(parteshoraActual[1], 10);
                      const segundoshoraActual = 13 + parseInt(parteshoraActual[2], 10);
                      const parteshoraTotal = horaTotal.split(":");
                      const horashoraTotal = parseInt(parteshoraTotal[0], 10);
                      const minutoshoraTotal = parseInt(parteshoraTotal[1], 10);
                      const segundoshoraTotal = parseInt(parteshoraTotal[2], 10);
                      const totalSegundoshoraActual = horashoraActual * 3600 + minutoshoraActual * 60 + segundoshoraActual;
                      const totalSegundoshoraTotal = horashoraTotal * 3600 + minutoshoraTotal * 60 + segundoshoraTotal;
                      porcentaje = (totalSegundoshoraActual * 100) / totalSegundoshoraTotal;
                      var ProgresoUnidad = {
                        idCurso: idCurso,
                        idUnidad: idUnidad,
                        idProgresoCurso: resultadosFiltrados[0].idProgresoCurso,
                        idPersonaCurso: resultadosFiltrados[0].idPersonaCurso,
                        idLeccion: resultadosFiltrados[0].idLeccion,
                        tiempoVideoActual: resultadosFiltrados[0].tiempoVideoActual,
                        tiempoVideoTotal: resultadosFiltrados[0].tiempoVideoTotal,
                        PorcentajeAvance: porcentaje > 100 ? 100 : porcentaje,
                      };
                      auxProgresoUnidad.push(ProgresoUnidad)
                      //console.log("ProgresoUnidad",ProgresoUnidad);
                      auxlistaProgresoLeccionUnidadeCursoPrograma.push(ProgresoUnidad);
                    }
                    else{
                      vLeccionesPendientesUnidad.leccionesPendientes.push(j + 1)
                    }
                  }
                  vLeccionesPendientesUnidades.push(vLeccionesPendientesUnidad);
                        var detalleunidad = auxProgresoUnidad.filter(
                          (x) => x.idUnidad == idUnidad
                        );
                        
                }
              }
            }
          });
        //console.log(vLeccionesPendientesUnidades);
        setLeccionesPendientes(vLeccionesPendientesUnidades);
        setlistaCursoPrograma(auxsetcursoPersona);
        setlistaUnidadeCursoPrograma(auxlistaUnidadeCursoPrograma);
        setlistaLeccionUnidadeCursoPrograma(auxlistaLeccionUnidadeCursoPrograma);
        setlistaProgresoLeccionUnidadeCursoPrograma(auxlistaProgresoLeccionUnidadeCursoPrograma);
        setlistaEvaluacionesUnidadeCursoPrograma(auxlistaEvaluacionesUnidadeCursoPrograma);
        var idCurso = auxsetcursoPersona[0].idCurso;
        setLoadingGlobal(true)
        await ListarBibliotecasPorCurso({ jwt, idCurso }).then((data) => {
          for (var B = 0; B < data.length; B++) {
            auxsetListaBiblioteca.push(data[B]);
          }
          setLoadingGlobal(false)
        });
        setListaBiblioteca(auxsetListaBiblioteca);
      })
    }
  }, [ListEvaluacionesPersonaPrograma]);

  function CursoEvaluacion(props) {
    if (listaEvaluacionesUnidadeCursoPrograma) {
      //var evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(x=>x.idUnidad === props.idUnidad)
      var unidades = listaUnidadeCursoPrograma.filter(
        (x) => x.idCurso === props.idCurso
      );
      var promediototal = 0;
      for (var k = 0; k < unidades.length; k++) {
        //  var Unidad = listaEvaluacionesUnidadeCursoPrograma.filter(x=>x.idUnidad === unidades[k].idUnidad)

        if (listaEvaluacionesUnidadeCursoPrograma.length > 0) {
          var evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(
            (x) => x.idUnidad === unidades[k].idUnidad
          );
          if (evaluacionesUnidad.length > 0) {
            const notas = evaluacionesUnidad.map(
              (evaluacion) => evaluacion.nota
            );
            const notaMasAlta = Math.max(...notas);
            promediototal = promediototal + notaMasAlta;
          }
        }
      }
      promediototal = promediototal / unidades.length;
      return (
        <span className="fontsizesmall ">
          Promedio del módulo{" "}
          {promediototal == 0 ? "--" : promediototal.toFixed()}
        </span>
      );
    } else {
      return (
        <span className="fontsizesmall ">
          Promedio del módulo --
        </span>
      );
    }
  }

  const Actualizar = () => {
    setLoading(true);
    let idPersonaCurso =
      listaCursoPrograma[cursoActivarSeleccion].idPersonaCurso;
    let idCurso = listaCursoPrograma[cursoActivarSeleccion].idCurso;
    let finCurso = listaCursoPrograma[cursoActivarSeleccion].finCurso;
    let idUsuario = listaCursoPrograma[cursoActivarSeleccion].idUsuario;
    let idEstado = 2;
    let jsonCurso = JSON.stringify(
      { idPersonaCurso, idUsuario, idCurso, finCurso, idEstado },
      null,
      2
    );
    let jwt = window.localStorage.getItem("jwt");

    ActualizarCursoEstado({ jsonCurso, jwt }).then((data) => {
      setTimeout(() => {
        setShowAlert(false);
        window.location.reload();
      }, 3000);
      setLoading(false);
    });
  };

  const footerActivar = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label="Activar curso"
          color="primary"
          onClick={() => Actualizar()}
        ></ButtonZegel>
      </div>
      <div>
        <ButtonZegel
          label="Cancelar"
          color="secondary"
          onClick={() => setShowAlert(false)}
        ></ButtonZegel>
      </div>
    </>
  );


  return (
    <>
      <div className="dashboard-progreso">
        <LoadingGlobal loadingGlobal={loadingGlobal} />

        <div className="progreso-header">
          <div className="container-center-auto">
            <button
              className="p-link-button button-img"
              onClick={() => navigate("/Inicio/Dashboard")}
              style={{
                fontWeight: "bold",
                color: "#000",
              }}
            >
              <i className="pi pi-arrow-left" style={{ fontSize: "1rem" }}></i>
            </button>
          </div>
        </div>

        <div className="progreso-contenido content-general-navigation">
          <MiProgresoTituloComponent />

          <div className="p-fluid formgrid grid">
            <CardBienvenidaProgramaComponent
              Persona={Persona}
              programa={programa}
              listaProgresoLeccionUnidadeCursoPrograma={
                listaProgresoLeccionUnidadeCursoPrograma
              }
              listaLeccionUnidadeCursoPrograma={listaLeccionUnidadeCursoPrograma}
              listaEvaluacionesUnidadeCursoPrograma={
                listaEvaluacionesUnidadeCursoPrograma
              }
              listaUnidadeCursoPrograma={listaUnidadeCursoPrograma}
              listaCursoPrograma={listaCursoPrograma}
              setspinnerCertificado={setspinnerCertificado}
              spinnerCertificado={spinnerCertificado}
              ProgressSpinner={ProgressSpinner}
              setspinnerNotas={setspinnerNotas}
              spinnerNotas={spinnerNotas}
              PersonaProgamaData={PersonaProgamaData}
            />

            {programa && <CardCursoVideoInicioComponent curso={programa} />}
          </div>


          <CardDownloadPrograma 
            listaCursoPrograma={listaCursoPrograma}
            listaEvaluacionesUnidadeCursoPrograma={listaEvaluacionesUnidadeCursoPrograma}
            Persona={Persona}
            programa={programa}
            listaUnidadeCursoPrograma={listaUnidadeCursoPrograma}
            setspinnerCertificado={setspinnerCertificado}
            spinnerCertificado={spinnerCertificado}
            ProgressSpinner={ProgressSpinner}
            setspinnerNotas={setspinnerNotas}
            spinnerNotas={spinnerNotas}
            PersonaProgamaData={PersonaProgamaData}
          />

          <AvanceModulosComponent
            listaCursoPrograma={listaCursoPrograma}
            listaProgresoLeccionUnidadeCursoPrograma={
              listaProgresoLeccionUnidadeCursoPrograma
            }
            listaUnidadeCursoPrograma={listaUnidadeCursoPrograma}
            listaLeccionUnidadeCursoPrograma={listaLeccionUnidadeCursoPrograma}
            listaEvaluacionesUnidadeCursoPrograma={
              listaEvaluacionesUnidadeCursoPrograma
            }
            CursoEvaluacion={CursoEvaluacion}
          />

          <ModulosAcordionProgramaComponent
            idPrograma={idPrograma}
            listaCursoPrograma={listaCursoPrograma}
            listaProgresoLeccionUnidadeCursoPrograma={
              listaProgresoLeccionUnidadeCursoPrograma
            }
            listaUnidadeCursoPrograma={listaUnidadeCursoPrograma}
            listaEvaluacionesUnidadeCursoPrograma={
              listaEvaluacionesUnidadeCursoPrograma
            }
            listaLeccionUnidadeCursoPrograma={listaLeccionUnidadeCursoPrograma}
            Persona={Persona}
            curso={curso}
            setListaBiblioteca={setListaBiblioteca}
            setcursoActivarSeleccion={setcursoActivarSeleccion}
            cursoActivarSeleccion={cursoActivarSeleccion}
            LeccionesPendientesUnidadCurso={LeccionesPendientes}
          />
          <BibliotecaVirtualComponent
            listaBiblioteca={listaBiblioteca}
            cursoPersona={cursoPersona}
          />
          <PreguntasFrecuentesComponent />
        </div>
        <FooterInterno />

        <DialogZegel
          header=""
          visible={showAlert}
          width="30vw"
          onHide={() => setShowAlert(false)}
          footer={footerActivar}
          contenido={contenidoAlertActivar}
        ></DialogZegel>
      </div>

    </>

  );
};

export default ProgresoPrograma;
